// A site's operationalStatus on admin.inrange.io, labelled as the admin app labels it.
// Must agree with STATUS_OPTIONS and LEGACY_STATUS_OPTIONS in
// frontends/packages/admin-app/src/routes/site/operationalStatusUtils.ts.
// In pipeline order, the retired statuses after the current ones.
const BMA_STATUS_LABELS: [string, string][] = [
  ["notStarted", "Not started"],
  ["offerMade", "Offer made"],
  ["designsAndValidating", "Designs and validating"],
  ["pendingSignatures", "Pending signatures"],
  ["constructionPlanning", "Construction planning"],
  ["installationInProgress", "Installation in progress"],
  ["operationalDemo", "Operational (demo)"],
  ["operational", "Operational"],
  ["closedLost", "Closed / Lost"],
  ["contractSigned", "Contract signed"],
  ["loaPending", "LOA pending"],
  ["gridAppPendingSurveyInProgress", "Grid app pending; Survey in progress"],
  ["gridAppPendingSurveyCompleted", "Grid app pending; Survey completed"],
  ["constructionPrelimsInProgress", "Construction prelims in progress"],
  ["installationRoofWorks", "Installation - roof works"],
  ["installationElectrical", "Installation - electrical"],
  ["witnessTestingInProgress", "Witness testing in progress"],
  ["waitingOnDnoWitnessTest", "Waiting on DNO - Witness test"],
];

const LABELS = new Map(BMA_STATUS_LABELS);
const ORDER = new Map(BMA_STATUS_LABELS.map(([status], i) => [status, i]));

/** A status BMA adds before this list learns it reads as BMA stores it. */
export const bmaStatusLabel = (status: string): string =>
  LABELS.get(status) ?? status;

/** The statuses given, each once, in pipeline order; any not listed last, A-Z. */
export const inPipelineOrder = (statuses: Iterable<string>): string[] =>
  [...new Set(statuses)].sort(
    (a, b) =>
      (ORDER.get(a) ?? ORDER.size) - (ORDER.get(b) ?? ORDER.size) ||
      a.localeCompare(b),
  );
